/**
 * Strona Oferta PPHU Imperium
 * Design: Industrial Precision
 * SEO: H1 zawiera usługę + miasto
 * Sekcje: Hero, Produkty, Proces współpracy, Obszar działania, FAQ
 */
import { Link } from 'wouter';
import { Phone, ArrowRight, ChevronDown, ChevronUp, MapPin } from 'lucide-react';
import { useState, useEffect, useCallback } from 'react';
import React from 'react';
import { companyData } from '@/theme';
import { trpc } from '@/lib/trpc';

const productSections = [
  {
    title: 'Elektronarzędzia Milwaukee',
    items: ['Wiertarki i wkrętarki akumulatorowe M18/M12', 'Szlifierki kątowe', 'Piły tarczowe i szablaste', 'Młoty udarowo-obrotowe', 'Klucze udarowe', 'Narzędzia wielofunkcyjne', 'Akumulatory i ładowarki'],
    highlight: true,
    desc: 'Autoryzowany punkt sprzedaży Milwaukee pełna gama narzędzi systemu M18 i M12 dostępna w stałej sprzedaży.',
    links: [
      { label: 'Milwaukee', url: 'https://pl.milwaukeetool.eu/', color: '#E31837', hoverColor: '#B5122A', textColor: '#fff' },
    ],
  },
  {
    title: 'Pneumatyka',
    items: ['Sprężarki tłokowe i śrubowe', 'Pistolety pneumatyczne', 'Klucze pneumatyczne', 'Węże i złączki', 'Zawory i regulatory ciśnienia'],
    highlight: false,
    desc: 'Kompletne wyposażenie do instalacji pneumatycznych dla warsztatów i zakładów produkcyjnych.',
    links: [
      { label: 'Rectus', url: 'https://rectus.pl/', color: '#0054A6', hoverColor: '#003F7E', textColor: '#fff' },
    ],
  },
  {
    title: 'Narzędzia warsztatowe',
    items: ['Klucze płaskie, oczkowe, nasadowe', 'Wkrętaki i zestawy bitów', 'Szczypce i obcęgi', 'Narzędzia udarowe ręczne', 'Zestawy narzędziowe'],
    highlight: false,
    desc: 'Narzędzia ręczne do codziennej pracy w warsztacie trwałe, precyzyjne, z gwarancją.',
    links: [
      { label: 'Jonnesway', url: 'https://www.jonnesway.pl/', color: '#2E7D32', hoverColor: '#1B5E20', textColor: '#fff' },
      { label: 'Wiha', url: 'https://wiha.com/pl/pl/', color: '#003DA5', hoverColor: '#002d7a', textColor: '#fff' },
      { label: 'Knipex', url: 'https://www.knipex.com/pl-pl', color: '#C8102E', hoverColor: '#9e0c24', textColor: '#fff' },
      { label: 'Beta', url: 'https://beta-polska.pl/', color: '#F5C400', hoverColor: '#d4a800', textColor: '#0D0D0D' },
      { label: 'Wera', url: 'https://www.wera.de/pl/', color: '#E87722', hoverColor: '#c45e10', textColor: '#fff' },
      { label: 'Luna', url: 'https://lunapolska.pl/', color: '#1B4F9B', hoverColor: '#143C77', textColor: '#fff' },
    ],
  },
  {
    title: 'Materiały ścierne',
    items: ['Tarcze tnące i szlifierskie', 'Papiery ścierne i taśmy', 'Ściernice garnkowe i talerzowe', 'Włókniny ścierne', 'Tarcze diamentowe'],
    highlight: false,
    desc: 'Materiały ścierne do metalu, betonu i drewna szeroki wybór ziarnistości i rozmiarów.',
    links: [
      { label: 'Luna', url: 'https://lunapolska.pl/', color: '#1B4F9B', hoverColor: '#143C77', textColor: '#fff' },
      { label: 'Tyrolit', url: 'https://www.tyrolit.com/pl-pl', color: '#0096D6', hoverColor: '#007CB0', textColor: '#fff' },
      { label: 'Klingspor', url: 'https://www.klingspor.pl/', color: '#C5B900', hoverColor: '#A69C00', textColor: '#0D0D0D' },
    ],
  },
  {
    title: 'Narzędzia skrawające',
    items: ['Wiertła do metalu, betonu, drewna', 'Frezy i frezarki', 'Płytki skrawające i oprawki', 'Piły otwornice', 'Narzędzia do gwintowania'],
    highlight: false,
    desc: 'Narzędzia skrawające ręczne i maszynowe do obróbki metalu, tworzyw i drewna.',
    links: [
      { label: 'Luna', url: 'https://lunapolska.pl/', color: '#1B4F9B', hoverColor: '#143C77', textColor: '#fff' },
    ],
  },
  {
    title: 'Narzędzia pomiarowe',
    items: ['Suwmiarki i mikrometry', 'Poziomice i piony laserowe', 'Taśmy miernicze', 'Mierniki cyfrowe', 'Czujniki zegarowe'],
    highlight: false,
    desc: 'Precyzyjne narzędzia pomiarowe dla wymagających zastosowań przemysłowych.',
    links: [
      { label: 'Luna', url: 'https://lunapolska.pl/', color: '#1B4F9B', hoverColor: '#143C77', textColor: '#fff' },
    ],
  },
  {
    title: 'Chemia techniczna',
    items: ['Smary i oleje przemysłowe', 'Środki czyszczące i odtłuszczające', 'Produkty z dopuszczeniem NSF (kontakt z żywnością)', 'Kleje i uszczelniacze', 'Preparaty antykorozyjne'],
    highlight: false,
    desc: 'Chemia techniczna, w tym produkty z certyfikatem NSF do zastosowań w przemyśle spożywczym.',
    links: [
      { label: 'NILS', url: 'https://nils-polska.pl/', color: '#E74A3B', hoverColor: '#C93628', textColor: '#fff' },
      { label: 'Luna', url: 'https://lunapolska.pl/', color: '#1B4F9B', hoverColor: '#143C77', textColor: '#fff' },
    ],
  },
  {
    title: 'Materiały i urządzenia spawalnicze',
    items: ['Elektrody i druty spawalnicze', 'Maski spawalnicze', 'Uchwyty i zaciski spawalnicze', 'Środki ochrony spawacza', 'Akcesoria spawalnicze'],
    highlight: false,
    desc: 'Kompletne wyposażenie stanowiska spawalniczego dla profesjonalistów.',
    links: [
      { label: 'ESAB', url: 'https://esab.com/pl/eur_pl/', color: '#FFD100', hoverColor: '#e0b800', textColor: '#0D0D0D' },
      { label: 'Kemppi', url: 'https://www.kemppi.com/pl/strona-glowna', color: '#F97316', hoverColor: '#ea6c00', textColor: '#fff' },
      { label: 'Spartus', url: 'https://spartus.pl/pl/', color: '#1565C0', hoverColor: '#0d47a1', textColor: '#fff' },
    ],
  },
  {
    title: 'Śruby, nakrętki i łożyska',
    items: ['Śruby metryczne i calowe', 'Nakrętki, podkładki, kołki', 'Łożyska toczne kulkowe i wałeczkowe', 'Elementy złączne nierdzewne', 'Śruby specjalne na zamówienie'],
    highlight: false,
    desc: 'Szeroki asortyment elementów złącznych i łożysk dostępne od ręki lub na zamówienie.',
    links: [
      { label: 'SKF', url: 'https://www.skf.com/pl/products/bearings', color: '#000000', hoverColor: '#262626', textColor: '#fff' },
      { label: 'NSK', url: 'https://www.nsk.com/eu-pl/', color: '#EE1937', hoverColor: '#C9142D', textColor: '#fff' },
      { label: 'Bossard', url: 'https://www.bossard.com/pl-pl/', color: '#0070BA', hoverColor: '#005A95', textColor: '#fff' },
    ],
  },
];

const processSteps = [
  {
    number: '01',
    title: 'Kontakt',
    desc: 'Zadzwoń pod numer +48 535 270 537 lub wyślij wiadomość przez formularz. Odpowiadamy od 1-3 dni.',
    icon: '📞',
  },
  {
    number: '02',
    title: 'Wycena',
    desc: 'Przygotowujemy ofertę cenową na podstawie Twoich potrzeb. W razie potrzeby możliwa wizja lokalna na terenie Sławna i okolic.',
    icon: '📋',
  },
  {
    number: '03',
    title: 'Realizacja',
    desc: 'Towar dostępny od ręki lub na zamówienie. Możliwy odbiór osobisty lub dostawa na terenie regionu.',
    icon: '🔧',
  },
  {
    number: '04',
    title: 'Odbiór i gwarancja',
    desc: 'Pełna gwarancja producenta na wszystkie produkty. Wsparcie posprzedażowe i pomoc w doborze narzędzi.',
    icon: '✅',
  },
];

const faqItems = [
  {
    q: 'Czy sprzedajecie wyłącznie elektronarzędzia Milwaukee?',
    a: 'Nie Milwaukee to nasza specjalność i autoryzowany punkt sprzedaży, ale w ofercie mamy znacznie więcej: pneumatykę, narzędzia warsztatowe, materiały ścierne, skrawające, pomiarowe, chemię techniczną, materiały spawalnicze, śruby, nakrętki i łożyska. Pełny asortyment dostępny w sklepie w Sławnie.',
  },
  {
    q: 'Czy obsługujecie firmy i zakłady produkcyjne?',
    a: 'Tak obsługujemy zarówno klientów indywidualnych, jak i firmy, zakłady produkcyjne, warsztaty samochodowe i firmy budowlane z całego województwa zachodniopomorskiego i pomorskiego. Możliwe faktury VAT i zamówienia hurtowe.',
  },
  {
    q: 'Jaki jest obszar dostawy lub dojazdu?',
    a: 'Sklep stacjonarny znajduje się w Sławnie (ul. Kosynierów 21). Obsługujemy klientów z całego regionu: Sławno, Słupsk, Koszalin, Darłowo, Ustka, Mielno, Sianów, Polanów i okolice. W przypadku większych zamówień możliwy dojazd do klienta.',
  },
  {
    q: 'Czy udzielacie gwarancji na produkty?',
    a: 'Tak wszystkie produkty objęte są gwarancją producenta. Elektronarzędzia Milwaukee posiadają standardową gwarancję producenta. Szczegółowe warunki gwarancji zależą od producenta i rodzaju produktu.',
  },
  {
    q: 'Czy możliwe jest zamówienie produktu, którego nie ma w magazynie?',
    a: 'Tak w przypadku produktów niedostępnych od ręki realizujemy zamówienia indywidualne. Czas realizacji zależy od dostępności u producenta lub dystrybutora. Skontaktuj się z nami, aby sprawdzić termin.',
  },
  {
    q: 'Jak mogę sprawdzić dostępność konkretnego produktu?',
    a: 'Najszybciej zadzwoń pod numer +48 535 270 537. Możesz też napisać na adres pphuimperium@gmail.com. Odpowiadamy od 1-3 dni.',
  },
];

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
          padding: '1.25rem 0',
          background: 'none',
          border: 'none',
          textAlign: 'left',
          cursor: 'pointer',
        }}
        aria-expanded={open}
      >
        <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontWeight: 700,
          fontSize: '1.05rem',
          color: '#F8F8F6',
          letterSpacing: '0.01em',
        }}
        >
          {q}
        </span>
        <span style={{ color: '#F5C400', flexShrink: 0 }}>
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </span>
      </button>
      {open && (
        <div style={{
          paddingBottom: '1.25rem',
          animation: 'fadeSlideDown 200ms ease',
        }}>
          <style>{`@keyframes fadeSlideDown { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }`}</style>
          <p style={{
            fontFamily: "'Manrope', sans-serif",
            fontSize: '0.9rem',
            color: 'rgba(248,248,246,0.65)',
            lineHeight: 1.75,
            margin: 0,
          }}>
            {a}
          </p>
        </div>
      )}
    </div>
  );
}

export default function Oferta() {
  const [isMobile, setIsMobile] = useState(false);
  const cmsContent = trpc.cms.public.content.useQuery();
  const cmsMedia = trpc.cms.public.media.useQuery();
  const offerHeroImage = cmsMedia.data?.find(item => item.slot === 'offer-hero')?.url || '/manus-storage/nils-lubricants-store_099f6342.jpg';
  const visibleProductSections = productSections.map((section, index) => ({
    ...section,
    desc: cmsContent.data?.[`offer.category.${index}`] || section.desc,
  }));
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  useEffect(() => {
    const scrollToHashTarget = () => {
      const targetId = window.location.hash.replace('#', '');
      if (!targetId) {
        window.scrollTo({ top: 0, behavior: 'instant' });
        return;
      }

      const target = document.getElementById(targetId);
      if (target) target.scrollIntoView({ behavior: 'instant', block: 'start' });
    };

    const timeoutId = window.setTimeout(scrollToHashTarget, 100);
    window.addEventListener('hashchange', scrollToHashTarget);
    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('hashchange', scrollToHashTarget);
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh' }}>

      {/* ============================================================
          HERO
          ============================================================ */}
      <section style={{
        position: 'relative',
        backgroundColor: '#111B30',
        overflow: 'hidden',
        minHeight: isMobile ? 'auto' : '60vh',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'stretch' : 'center',
      }}>
        {/* LEFT PANEL text */}
        <div style={{
          flex: isMobile ? 'none' : '0 0 58%',
          width: isMobile ? '100%' : undefined,
          backgroundColor: '#111B30',
          minHeight: isMobile ? 'auto' : '60vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          zIndex: 1,
          paddingLeft: isMobile ? '1.25rem' : 'max(2rem, calc((100vw - 1280px) / 2 + 2rem))',
          paddingRight: isMobile ? '1.25rem' : '4rem',
          paddingTop: isMobile ? '5.5rem' : '5rem',
          paddingBottom: isMobile ? '2rem' : '5rem',
        }}>
          {/* Yellow accent bar */}
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', backgroundColor: '#F5C400' }} aria-hidden="true" />
          {/* Grid overlay */}
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: 'linear-gradient(rgba(245,196,0,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(245,196,0,0.025) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
            pointerEvents: 'none',
          }} aria-hidden="true" />
          <div style={{ maxWidth: '600px', position: 'relative' }}>
            <div className="section-label" style={{ marginBottom: '1rem' }}>Pełny asortyment</div>
            <h1 style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(1.75rem, 4vw, 3rem)',
              textTransform: 'uppercase',
              color: '#F8F8F6',
              letterSpacing: '-0.02em',
              lineHeight: 1.05,
              marginBottom: '1.25rem',
            }}>
              Narzędzia i elektronarzędzia{' '}
              <span style={{ color: '#E31837' }}>Milwaukee</span>{' '}
              Sławno
            </h1>
            <p style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: 'clamp(0.9rem, 1.6vw, 1.05rem)',
              color: 'rgba(248,248,246,0.7)',
              lineHeight: 1.75,
              maxWidth: '520px',
              marginBottom: '2rem',
            }}>
              {cmsContent.data?.['offer.hero.description'] || '9 kategorii produktów. Obsługujemy firmy i klientów indywidualnych z województwa zachodniopomorskiego i pomorskiego. Odbiór osobisty w Sławnie lub dostawa na terenie regionu.'}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
              <a href={`tel:${companyData.phoneRaw}`} className="btn-primary">
                <Phone size={16} />
                Zadzwoń: {companyData.phone}
              </a>
              <Link href="/kontakt" className="btn-secondary">
                Formularz kontaktowy
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
        {/* RIGHT PANEL photo NILS */}
        <div style={{
          flex: isMobile ? 'none' : '0 0 42%',
          width: isMobile ? '100%' : undefined,
          height: isMobile ? '240px' : undefined,
          minHeight: isMobile ? 'auto' : '60vh',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${offerHeroImage})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          clipPath: isMobile ? 'none' : 'polygon(8% 0, 100% 0, 100% 100%, 0% 100%)',
          pointerEvents: 'none',
          }} aria-hidden="true" />
          <div style={{
            position: 'absolute',
            inset: 0,
          background: isMobile
            ? 'linear-gradient(to bottom, rgba(17,27,48,0.5) 0%, rgba(17,27,48,0.1) 100%)'
            : 'linear-gradient(to right, rgba(17,27,48,0.35) 0%, rgba(17,27,48,0.05) 60%)',
          clipPath: isMobile ? 'none' : 'polygon(8% 0, 100% 0, 100% 100%, 0% 100%)',
          pointerEvents: 'none',
          }} aria-hidden="true" />
        </div>
      </section>

      {/* ============================================================
          ASORTYMENT siatka produktów
          ============================================================ */}
      <section id="asortyment" style={{ backgroundColor: '#F8F8F6', padding: '5rem 0' }}>
        <div className="container">
          <div style={{ marginBottom: '3rem' }}>
            <div className="section-label" style={{ color: '#1A2744' }}>
              <span style={{ backgroundColor: '#1A2744', width: '24px', height: '3px', display: 'block' }} />
              Co znajdziesz w naszym sklepie
            </div>
            <h2 style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
              textTransform: 'uppercase',
              color: '#0D0D0D',
              letterSpacing: '-0.01em',
            }}>
              Pełny asortyment
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.5rem',
          }}>
         {visibleProductSections.map((section, i) => (
            <React.Fragment key={i}>
            {(section as any).links ? (
              <div
               id={`kat-${i}`}
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #E31837',
                  borderRadius: '2px',
                  scrollMarginTop: '80px',
                  padding: '1.75rem',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <h3 style={{
                  fontFamily: "'Manrope', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.2rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  color: '#0D0D0D',
                  marginBottom: '0.625rem',
                }}>
                  {section.title}
                </h3>
                <p style={{
                  fontSize: '0.8rem',
                  color: '#6B7280',
                  lineHeight: 1.6,
                  marginBottom: '1rem',
                }}>
                  {section.desc}
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.375rem', marginBottom: '1.25rem' }}>
                  {section.items.map((item, j) => (
                    <li key={j} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.5rem',
                      fontSize: '0.85rem',
                      color: '#374151',
                      lineHeight: 1.5,
                    }}>
                      <span style={{ color: '#F5C400', flexShrink: 0, marginTop: '2px', fontSize: '0.7rem' }}>▸</span>
                      {item}
                    </li>
                  ))}
                </ul>
                <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginTop: 'auto' }}>
                {(section as any).links.map((lnk: { label: string; url: string; color?: string; hoverColor?: string; textColor?: string }, li: number) => (
                   <a
                     key={li}
                     href={lnk.url}
                     target="_blank"
                     rel="noopener noreferrer"
                     style={{
                       display: 'inline-block',
                       padding: '0.5rem 1.25rem',
                        backgroundColor: lnk.color || (li === 0 ? '#F5C400' : '#F97316'),
                        color: lnk.textColor || (li === 0 ? '#0D0D0D' : '#fff'),
                       fontFamily: "'Manrope', sans-serif",
                       fontWeight: 700,
                       fontSize: '0.8rem',
                       textTransform: 'uppercase',
                       letterSpacing: '0.06em',
                       textDecoration: 'none',
                       borderRadius: '2px',
                       transition: 'background-color 160ms ease',
                     }}
                      onMouseEnter={e => { (e.currentTarget as HTMLElement).style.backgroundColor = lnk.hoverColor || (li === 0 ? '#d4a800' : '#ea6c00'); }}
                      onMouseLeave={e => { (e.currentTarget as HTMLElement).style.backgroundColor = lnk.color || (li === 0 ? '#F5C400' : '#F97316'); }}
                    >
                      {lnk.label}
                    </a>
                  ))}
                </div>
              </div>
             ) : (
               <a
                key={i}
                href={(section as any).link || '#'}
                target={(section as any).link ? '_blank' : '_self'}
                rel={(section as any).link ? 'noopener noreferrer' : undefined}
                onClick={!(section as any).link ? (e: React.MouseEvent) => e.preventDefault() : undefined}
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #E31837',
                  borderRadius: '2px',
                  scrollMarginTop: '80px',
                  padding: '1.75rem',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'transform 200ms cubic-bezier(0.23, 1, 0.32, 1), box-shadow 200ms cubic-bezier(0.23, 1, 0.32, 1)',
                  cursor: (section as any).link ? 'pointer' : 'default',
                  display: 'block',
                  textDecoration: 'none',
                }}
                id={`kat-${i}`}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                  (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(227,24,55,0.12)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                  (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                }}
              >
                <h3 style={{
                  fontFamily: "'Manrope', sans-serif",
                  fontWeight: 800,
                  fontSize: '1.2rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  color: '#0D0D0D',
                  marginBottom: '0.625rem',
                }}>
                  {section.title}
                </h3>
                <p style={{
                  fontSize: '0.8rem',
                  color: '#6B7280',
                  lineHeight: 1.6,
                  marginBottom: '1rem',
                }}>
                  {section.desc}
                </p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
                  {section.items.map((item, j) => (
                    <li key={j} style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '0.5rem',
                      fontSize: '0.85rem',
                      color: '#374151',
                      lineHeight: 1.5,
                    }}>
                      <span style={{ color: '#F5C400', flexShrink: 0, marginTop: '2px', fontSize: '0.7rem' }}>▸</span>
                      {item}
                    </li>
                  ))}
                </ul>
             </a>
            )}
            </React.Fragment>
           ))}
          </div>
        </div>
      </section>

      {/* ============================================================
          PROCES WSPÓŁPRACY
          ============================================================ */}
      <section style={{ backgroundColor: '#0D0D0D', padding: '5rem 0' }}>
        <div className="container">
          <div style={{ marginBottom: '3rem' }}>
            <div className="section-label">Jak działamy</div>
            <h2 style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
              textTransform: 'uppercase',
              color: '#F8F8F6',
              letterSpacing: '-0.01em',
            }}>
              Proces współpracy
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '0',
            position: 'relative',
          }}>
            {processSteps.map((step, i) => (
              <div
                key={i}
                style={{
                  padding: '2rem 1.75rem',
                  borderLeft: i > 0 ? '1px solid rgba(255,255,255,0.06)' : 'none',
                  position: 'relative',
                }}
              >
                <div style={{
                  fontFamily: "'Manrope', sans-serif",
                  fontWeight: 800,
                  fontSize: '4rem',
                  color: 'rgba(245,196,0,0.12)',
                  lineHeight: 1,
                  marginBottom: '0.5rem',
                  userSelect: 'none',
                }}>
                  {step.number}
                </div>
                <div style={{ fontSize: '1.75rem', marginBottom: '0.75rem' }}>{step.icon}</div>
                <h3 style={{
                  fontFamily: "'Manrope', sans-serif",
                  fontWeight: 700,
                  fontSize: '1.2rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  color: '#F5C400',
                  marginBottom: '0.75rem',
                }}>
                  {step.title}
                </h3>
                <p style={{
                  fontSize: '0.875rem',
                  color: 'rgba(248,248,246,0.6)',
                  lineHeight: 1.7,
                  margin: 0,
                }}>
                  {step.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============================================================
          OBSZAR DZIAŁANIA
          ============================================================ */}
      <section style={{ backgroundColor: '#1A2744', padding: '4rem 0' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '3rem',
            alignItems: 'center',
          }}>
            <div>
              <div className="section-label">Zasięg obsługi</div>
              <h2 style={{
                fontFamily: "'Manrope', sans-serif",
                fontWeight: 800,
                fontSize: 'clamp(1.5rem, 3.5vw, 2.25rem)',
                textTransform: 'uppercase',
                color: '#F8F8F6',
                letterSpacing: '-0.01em',
                marginBottom: '1.25rem',
              }}>
                Obszar działania
              </h2>
              <p style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: '0.95rem',
                color: 'rgba(248,248,246,0.7)',
                lineHeight: 1.75,
                marginBottom: '1.5rem',
              }}>
                Sklep stacjonarny PPHU Imperium mieści się w <strong style={{ color: '#F5C400' }}>Sławnie przy ul. Kosynierów 21</strong>.
                Obsługujemy klientów z całego <strong style={{ color: '#F5C400' }}>województwa zachodniopomorskiego i pomorskiego</strong>.
              </p>
              <p style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: '0.95rem',
                color: 'rgba(248,248,246,0.7)',
                lineHeight: 1.75,
              }}>
                Narzędzia i elektronarzędzia Milwaukee dostępne są dla firm i klientów indywidualnych
                z całego regionu. Przy większych zamówieniach możliwy dojazd do klienta.
              </p>
            </div>
            <div>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.625rem',
              }}>
              {companyData.serviceArea.map((city) => (
                  null
                ))}
               {[
                  { label: 'Województwo zachodniopomorskie', url: 'https://www.google.com/maps/search/województwo+zachodniopomorskie' },
                  { label: 'Województwo pomorskie', url: 'https://www.google.com/maps/search/województwo+pomorskie' },
                ].map((woj) => (
                  <a
                    key={woj.label}
                    href={woj.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.375rem',
                      backgroundColor: 'rgba(245,196,0,0.1)',
                      border: '1px solid rgba(245,196,0,0.25)',
                      borderRadius: '2px',
                      padding: '0.5rem 0.875rem',
                      fontFamily: "'Manrope', sans-serif",
                      fontWeight: 700,
                      fontSize: '0.85rem',
                      letterSpacing: '0.04em',
                      textTransform: 'uppercase',
                      color: 'rgba(248,248,246,0.75)',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'background-color 150ms ease, border-color 150ms ease',
                    }}
                    onMouseEnter={e => {
                      (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(245,196,0,0.2)';
                      (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(245,196,0,0.5)';
                    }}
                    onMouseLeave={e => {
                      (e.currentTarget as HTMLAnchorElement).style.backgroundColor = 'rgba(245,196,0,0.1)';
                      (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(245,196,0,0.25)';
                    }}
                  >
                    <MapPin size={12} />
                    {woj.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ============================================================
          FAQ
          ============================================================ */}
      <section style={{ backgroundColor: '#111B30', padding: '5rem 0' }}>
        <div className="container">
          <div style={{ marginBottom: '3rem' }}>
            <div className="section-label">Pytania i odpowiedzi</div>
            <h2 style={{
              fontFamily: "'Manrope', sans-serif",
              fontWeight: 800,
              fontSize: 'clamp(1.75rem, 4vw, 2.75rem)',
              textTransform: 'uppercase',
              color: '#F8F8F6',
              letterSpacing: '-0.01em',
            }}>
              Często zadawane pytania
            </h2>
          </div>
          <div style={{ maxWidth: '800px' }}>
            {faqItems.map((item, i) => (
              <FaqItem key={i} q={item.q} a={item.a} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ backgroundColor: '#F5C400', padding: '3.5rem 0' }}>
        <div className="container" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '1.5rem' }}>
          <div>
            <h2 style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: 'clamp(1.25rem, 3vw, 2rem)', textTransform: 'uppercase', color: '#0D0D0D', margin: '0 0 0.25rem' }}>
              Masz pytanie o produkt?
            </h2>
            <p style={{ fontFamily: "'Manrope', sans-serif", fontSize: '0.95rem', color: 'rgba(13,13,13,0.65)', margin: 0 }}>
              Zadzwoń lub napisz.
            </p>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
            <a href={`tel:${companyData.phoneRaw}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', backgroundColor: '#0D0D0D', color: '#F5C400', fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '0.95rem', letterSpacing: '0.06em', textTransform: 'uppercase', padding: '0.75rem 1.5rem', borderRadius: '2px', textDecoration: 'none' }}>
              <Phone size={16} />
              {companyData.phone}
            </a>
            <Link href="/kontakt" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', backgroundColor: 'transparent', color: '#0D0D0D', fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '0.95rem', letterSpacing: '0.06em', textTransform: 'uppercase', padding: '0.75rem 1.5rem', borderRadius: '2px', border: '2px solid #0D0D0D', textDecoration: 'none' }}>
              Formularz kontaktowy
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}
